import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, EntryTypeItem } from './styles';
import { EPurchaseRoutes } from '../../../purchase.routes';
import { ERoutes } from '../../../../../routes';
import { EOrderSettingsRoutes } from '../orderSettings.routes';
import { useDispatch, useSelector } from 'react-redux';
import {
  cleanSearchItemErrors,
  removeSearchedItem
} from '../../../../../store/ducks/long-steel-order-item-search/actions';
import { ApplicationState } from '../../../../../store';
import { CardTextButtons } from '@gerdau/hefesto/CardTextButtons';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { setTaggingInfoPreviousScreen } from '../../../../../store/ducks/long-steel-shopping-cart/actions';
import { ordersType } from '../../../../../store/ducks/long-steel-orders/types';
interface IEntryTypeProps {
  emitterId: string;
}

const EntryType: React.FC<IEntryTypeProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const orderItemSearch = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch
  );

  const auxScreenName: ordersType = {
    'search-items': 'SelecaoItens',
    'repeat-order': 'RefazerPedido',
    'spreadsheet-upload': 'PedidoViaPlanilha'
  };

  const auxItemDescription: ordersType = {
    'search-items': 'selecaoItens',
    'repeat-order': 'refazerPedido',
    'spreadsheet-upload': 'pedidoViaPlanilha'
  };

  const redirectTo = (orderSettingsRoute: EOrderSettingsRoutes) => {
    dispatch(
      setTaggingInfoPreviousScreen({
        screenName: auxScreenName[orderSettingsRoute],
        itemDescription: auxItemDescription[orderSettingsRoute]
      })
    );
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${orderSettingsRoute}`
    );
  };

  const cleanSearchedItems = () => {
    dispatch(removeSearchedItem([]));
  };

  const cleanErrors = () => {
    dispatch(cleanSearchItemErrors());
  };

  const { screenName = '' } = getTaggingInformationScreen(
    history.location.pathname,
    true
  );

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: screenName,
        page: window.location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  useEffect(() => {
    if (orderItemSearch?.searchedItems?.length > 0) {
      cleanSearchedItems();
    }
  });

  useEffect(() => {
    if (
      orderItemSearch?.searchingItemsError ||
      orderItemSearch?.searchingItemsSpreadsheetError ||
      orderItemSearch?.searchingItemsLastOrderError
    ) {
      cleanErrors();
    }
  });

  return (
    <Container>
      <EntryTypeItem>
        <CardTextButtons
          title="Com base no histórico"
          description="Selecione um pedido já realizado e adicione ou remova itens para completar sua compra."
          buttonProps={{
            label: 'Comprar com base no histórico',
            onClick: () => {
              dispatch(
                sendTagging({
                  screenName: screenName,
                  event: 'click',
                  itemName: 'button:comprarBaseHistorico',
                  itemDescription: 'comprar_acosLongos_comprarBaseHistorico'
                })
              );
              redirectTo(EOrderSettingsRoutes.REPEAT_ORDER);
            }
          }}
        />
      </EntryTypeItem>

      <EntryTypeItem>
        <CardTextButtons
          title="Selecionando itens"
          description="Selecione e adicione os itens desejados para o seu pedido inserindo os códigos do SKU ou pesquisando pela descrição do material."
          buttonProps={{
            label: 'Comprar selecionando itens',
            onClick: () => {
              dispatch(
                sendTagging({
                  screenName: screenName,
                  event: 'click',
                  itemName: 'button:comprarSelecionandoItens',
                  itemDescription:
                    'comprar_acosLongos_refazerPedido_selecao_comprarSelecionandoItens'
                })
              );
              redirectTo(EOrderSettingsRoutes.SEARCH_ITEMS);
            }
          }}
        />
      </EntryTypeItem>

      <EntryTypeItem>
        <CardTextButtons
          title="Via planilha"
          description="Adicione uma planilha de excel contendo o código dos SKUs, unidade de medida, quantidade e data desejada, e faremos a leitura do seu pedido automaticamente."
          buttonProps={{
            label: 'Comprar via planilha',
            onClick: () => {
              dispatch(
                sendTagging({
                  screenName: screenName,
                  event: 'click',
                  itemName: 'button:comprarViaPlanilha',
                  itemDescription:
                    'comprar_acosLongos_refazerPedido_selecao_comprarViaPlanilha'
                })
              );
              redirectTo(EOrderSettingsRoutes.SPREADSHEET_UPLOAD);
            }
          }}
        />
      </EntryTypeItem>
    </Container>
  );
};

export default EntryType;
